<template>
    <portal to="app">
        <modal name="table-configurator"
               :width="480"
               height="auto"
               :scrollable="true">
            <fup-modal-constructor @close="closeTableConfigurator"
                                   title="Настройка таблицы"
                                   icon="wrench">
                <template slot="default">
                    <template v-if="tableFields">
                        <h3>Колонки таблицы</h3>
                        <p>Вы можете отключить ненужные колонки и изменить их порядок</p>
                        <fup-draggable v-if="configuredTableFields && configuratorModal"
                                       tag="ul"
                                       v-model="configuredTableFields"
                                       class="list-group"
                                       handle=".handle"
                                       @change="saveTableConfig">
                            <li onselectstart="return false" class="list-group-item"
                                v-for="(element, idx) in configuredTableFields" :key="element.key">
                                <b-form-checkbox v-model="element.show" switch @input="saveTableConfig"
                                                 :disabled="configuredTableFieldsActive && element.show">
                                    <fup-icon name="sort" class="text-muted mr-2 handle" :class="$style.handle"/>
                                    {{ element.label }}
                                </b-form-checkbox>
                            </li>
                        </fup-draggable>
                    </template>
                </template>
                <template slot="footer">
                    <div class="actions">
                        <b-button @click="resetTableFields">Сбросить по умолчанию</b-button>
                        <b-button @click="closeTableConfigurator" variant="warning">Готово</b-button>
                    </div>
                </template>
            </fup-modal-constructor>
        </modal>
    </portal>
</template>

<script>
    import filter from 'lodash/filter'

    export default {
        name: "TableConfigurator",
        props: {
            tableFields: null
        },
        data() {
            return {
                configuredTableFields: null,
                isTableFieldsChanged: false,
                configuratorModal: false,
            }
        },
        computed: {
            configuredTableFieldsActive() {
                let result = 0;
                for (let item of this.$data.configuredTableFields) {
                    if (item.show) {
                        result++;
                    }
                }
                return !(result > 1);
            }
        },
        mounted() {
            this.setFieldsData();
        },
        methods: {
            setFieldsData() {
                if (this.$props.tableFields) {
                    if (!Array.isArray(this.$data.configuredTableFields)) {
                        this.$data.configuredTableFields = [].concat(this.$props.tableFields);
                    } else if (this.$data.configuredTableFields.length !== this.$props.tableFields.length) {
                        this.$data.configuredTableFields = [].concat(this.$props.tableFields);
                    }
                    this.$emit('fields-setup', filter(this.$data.configuredTableFields, {show: true}));
                    this.$data.isTableFieldsChanged = this.hash(this.$props.tableFields) !== this.hash(this.$data.configuredTableFields);
                }
            },
            resetTableFields() {
                this.$data.configuredTableFields = [].concat(this.$props.tableFields);
                this.$data.isTableFieldsChanged = this.hash(this.$props.tableFields) !== this.hash(this.$data.configuredTableFields);
                this.$emit('fields-changed', this.$data.configuredTableFields);
                this.$modal.hide('table-configurator');
                this.$forceUpdate();
            },
            open() {
                this.$data.configuratorModal = true;
                this.$modal.show('table-configurator');
            },
            closeTableConfigurator() {
                this.$data.configuratorModal = false;
                this.$modal.hide('table-configurator');
            },
            saveTableConfig() {
                this.$data.isTableFieldsChanged = this.hash(this.$props.tableFields) !== this.hash(this.$data.configuredTableFields);
                this.$emit('fields-changed', filter(this.$data.configuredTableFields, {show: true}));
            },
        }
    }
</script>
<style lang="scss" module>
    .handle {
        cursor: move;
    }
</style>